import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import moment from 'moment';
import Table from './common/Table';
import common from '../utils/Common';
import { exportToCSV, exportToExcel, exportToPDF } from '../utils/Exports';

const BalanceOutstanding = () => {
  const [data, setData] = useState([]);
  // const [startDate, setStartDate] = useState(() => moment().format('YYYY-MM-DD'));
  // const [endDate, setEndDate] = useState(() => moment().format('YYYY-MM-DD'));
  const [startDate, setStartDate] = useState('00-00-00');
const [endDate, setEndDate] = useState('00-00-00');

  const [loading, setLoading] = useState(false);
  
  const [orderDetailsModal, setOrderDetailsModal] = useState(false);
  const [logisticsDetailsModal, setLogisticsDetailsModal] = useState(false);
  const [onlineOrdersModal, setOnlineOrdersModal] = useState(false);
  const [offlineOrdersModal, setOfflineOrdersModal] = useState(false);
  const [serviceOrdersModal, setServiceOrdersModal] = useState(false);
  const [logisticsOrdersModal, setLogisticsOrdersModal] = useState(false);
  const [usersWalletModal, setUsersWalletModal] = useState(false);
  
  const [orderDetailsData, setOrderDetailsData] = useState([]);
  const [logisticsDetailsData, setLogisticsDetailsData] = useState([]);
  const [onlineOrdersData, setOnlineOrdersData] = useState([]);
  const [offlineOrdersData, setOfflineOrdersData] = useState([]);
  const [serviceOrdersData, setServiceOrdersData] = useState([]);
  const [logisticsOrdersData, setLogisticsOrdersData] = useState([]);
  const [usersWalletData, setUsersWalletData] = useState([]);
  
  const [modalTitle, setModalTitle] = useState('');

  useEffect(() => {
    fetchBalanceData();
  }, [startDate, endDate]);

  const fetchBalanceData = async () => {
    setLoading(true);
    try {
      let requestData = {
        'start_date': startDate,
        'end_date': endDate,
      };
      let response = await common.apiRequest('post', '/admin/balance-outstanding', requestData);
      if (response.data.code === 'success') {
        setData(response.data.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error('Error fetching balance data:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchDetails = async (ids, modalType, title) => {
    
    if (!ids || (Array.isArray(ids) && ids.length === 0)) {
      alert('No IDs provided for fetching details');
      return;
    }
    setLoading(true);
    try {
      let requestData = {
        'start_date': startDate,
        'end_date': endDate,
        'ids': ids,
        'modalType': modalType,
      };
      
      let response = await common.apiRequest('post', '/admin/balance-outstanding-details', requestData);
      
      if (response.data.code === 'success') {
        const responseData = response.data.data || [];
        setModalTitle(title);
        
        switch(modalType) {
          case 'order_details':
            setOrderDetailsData(responseData);
            setOrderDetailsModal(true);
            break;
          case 'logistics_details':
            setLogisticsDetailsData(responseData);
            setLogisticsDetailsModal(true);
            break;
          case 'online_orders':
            setOnlineOrdersData(responseData);
            setOnlineOrdersModal(true);
            break;
          case 'offline_orders':
            setOfflineOrdersData(responseData);
            setOfflineOrdersModal(true);
            break;
          case 'service_orders':
            setServiceOrdersData(responseData);
            setServiceOrdersModal(true);
            break;
          case 'logistics_orders':
            setLogisticsOrdersData(responseData);
            setLogisticsOrdersModal(true);
            break;
          case 'users_wallet':
            setUsersWalletData(responseData);
            setUsersWalletModal(true);
            break;
          default:
            break;
        }
      } else {
        console.error('API Error:', response.data.error);
        alert(response.data.error || 'Error fetching details');
      }
    } catch (error) {
      console.error('Error fetching details:', error);
      alert('Error fetching details: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  // Generic function to prepare export data for different modal types
  const prepareExportData = (data, modalType) => {
    return data.map((item, index) => {
      const baseData = {
        "S.No": index + 1,
      };

      if (modalType === 'users_wallet') {
        return {
          ...baseData,
          "Customer Name": `${item?.first_name || ''} ${item?.last_name || ''}`.trim(),
          "Reg ID": item?.reg_id || '',
          "Business Name": item?.user_business?.business_name || '',
          "Wallet Amount": item?.wallet || 0,
        };
      } else {
        // For all other modal types (orders, logistics, etc.)
        let customerName = '';
        let regId = '';
        let businessName = '';
        let natureOfBusiness = '';
        let amount = 0;

        if (item?.seller) {
          customerName = `${item.seller.first_name || ''} ${item.seller.last_name || ''}`.trim();
          regId = item.seller.reg_id || '';
          businessName = item.seller.user_business?.business_name || '';
          natureOfBusiness = item.seller.user_business?.nature_of_business || '';
        } else if (item?.order?.user) {
          customerName = `${item.order.user.first_name || ''} ${item.order.user.last_name || ''}`.trim();
          regId = item.order.user.reg_id || '';
          businessName = item.order.user.user_business?.business_name || '';
          natureOfBusiness = item.order.user.user_business?.nature_of_business || '';
        } else if (item?.first_name || item?.last_name) {
          customerName = `${item.first_name || ''} ${item.last_name || ''}`.trim();
          regId = item.reg_id || '';
          businessName = item.user_business?.business_name || '';
          natureOfBusiness = item.user_business?.nature_of_business || '';
        }

        if (item?.total_order_price) {
          amount = item.total_order_price;
        } else if (item?.order_price) {
          amount = item.order_price;
        } else if (item?.amount) {
          amount = item.amount;
        } else if (item?.wallet) {
          amount = item.wallet;
        }

        return {
          ...baseData,
          "Customer Name": customerName,
          "Reg ID": regId,
          "Business Name": businessName,
          "Nature of Business": natureOfBusiness,
          "Outstanding Amount": amount,
        };
      }
    });
  };

  // Export functions for different modal types
  const handleExportDetailCSV = (data, modalType, title) => {
    const exportData = prepareExportData(data, modalType);
    exportToCSV(exportData, title);
  };

  const handleExportDetailExcel = (data, modalType, title) => {
    const exportData = prepareExportData(data, modalType);
    exportToExcel(exportData, title);
  };

  const handleExportDetailPDF = (data, modalType, title) => {
    const exportData = prepareExportData(data, modalType);
    exportToPDF(exportData, title);
  };

  const toggleOrderDetailsModal = () => {
    setOrderDetailsModal(!orderDetailsModal);
    if (orderDetailsModal) {
      setOrderDetailsData([]);
    }
  };

  const toggleLogisticsDetailsModal = () => {
    setLogisticsDetailsModal(!logisticsDetailsModal);
    if (logisticsDetailsModal) {
      setLogisticsDetailsData([]);
    }
  };

  const toggleOnlineOrdersModal = () => {
    setOnlineOrdersModal(!onlineOrdersModal);
    if (onlineOrdersModal) {
      setOnlineOrdersData([]);
    }
  };

  const toggleOfflineOrdersModal = () => {
    setOfflineOrdersModal(!offlineOrdersModal);
    if (offlineOrdersModal) {
      setOfflineOrdersData([]);
    }
  };

  const toggleServiceOrdersModal = () => {
    setServiceOrdersModal(!serviceOrdersModal);
    if (serviceOrdersModal) {
      setServiceOrdersData([]);
    }
  };

  const toggleLogisticsOrdersModal = () => {
    setLogisticsOrdersModal(!logisticsOrdersModal);
    if (logisticsOrdersModal) {
      setLogisticsOrdersData([]);
    }
  };

  const toggleUsersWalletModal = () => {
    setUsersWalletModal(!usersWalletModal);
    if (usersWalletModal) {
      setUsersWalletData([]);
    }
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount || 0);
  };

  const columnDefs = [
    {
      header: "Particular Name",
      accessor: "particular_name",
      sortable: false,
      filter: false,
      width: 300,
      render: (row) => (
        <div className="font-weight-bold text-dark">
          {row.particular_name}
        </div>
      )
    },
    {
      header: "Amounts (Rs.)",
      accessor: "amount",
      sortable: true,
      filter: false,
      width: 200,
      render: (row) => (
        <div className="text-right font-weight-bold text-primary">
          {formatCurrency(row.amount)}
        </div>
      )
    },
    {
      header: "Reports",
      accessor: "reports",
      sortable: false,
      filter: false,
      width: 300,
      render: (row) => {
        const balanceData = data && data.length > 0 ? data[0] : {};
        
        switch(row.type) {
          case 'total_outstanding':
            return (
              <div className="d-flex gap-2">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => {
                    const allOrderIds = balanceData.total_online_sale_order_ids

                    fetchDetails(allOrderIds, 'order_details', 'Total Outstanding - Order Details');
                  }}
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Order Details"}
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => {
                    const logisticsIds = balanceData.total_logistic_vendors_order_ids;
                    fetchDetails(logisticsIds, 'logistics_details', 'Total Outstanding - Logistics Details');
                  }}
                  disabled={loading || !balanceData.total_logistic_vendors_order_ids}
                >
                  {loading ? "Loading..." : "Logistics Details"}
                </button>
              </div>
            );
          case 'online_suppliers':
            return (
              <button
                className="btn btn-sm btn-outline-success"
                onClick={() => {
                  const ids = balanceData.total_online_sale_order_ids;
                  fetchDetails(ids, 'online_orders', 'Online Suppliers Outstanding Details');
                }}
                disabled={loading || !balanceData.total_online_sale_order_ids}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          case 'offline_suppliers':
            return (
              <button
                className="btn btn-sm btn-outline-warning"
                onClick={() => {
                  const ids = balanceData.total_offline_suppliers_order_ids;
                  fetchDetails(ids, 'offline_orders', 'Offline Suppliers Outstanding Details');
                }}
                disabled={loading || !balanceData.total_offline_suppliers_order_ids}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          case 'service_suppliers':
            return (
              <button
                className="btn btn-sm btn-outline-info"
                onClick={() => {
                  const ids = balanceData.total_service_suppliers_order_ids;
                  fetchDetails(ids, 'service_orders', 'Service Suppliers Outstanding Details');
                }}
                disabled={loading || !balanceData.total_service_suppliers_order_ids}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          case 'logistics_vendors':
            return (
              <button
                className="btn btn-sm btn-outline-dark"
                onClick={() => {
                  const ids = balanceData.total_logistic_vendors_order_ids;
                  fetchDetails(ids, 'logistics_orders', 'Logistics Vendors Outstanding Details');
                }}
                disabled={loading || !balanceData.total_logistic_vendors_order_ids}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          case 'users_wallet':
            return (
              <button
                className="btn btn-sm btn-outline-primary"
                onClick={() => {
                  const ids = balanceData.total_users_wallet_ids;
                  fetchDetails(ids, 'users_wallet', 'Users Wallet Outstanding Details');
                }}
                disabled={loading || !balanceData.total_users_wallet_ids}
              >
                {loading ? "Loading..." : "View Details"}
              </button>
            );
          default:
            return (
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled
              >
                No Details
              </button>
            );
        }
      }
    }
  ];
  

  const getTableData = () => {
    if (!data || data.length === 0) return [];
    
    const balanceData = data[0];
    
    return [
      {
        particular_name: "Total Outstanding Amount",
        amount: balanceData.total_outstanding_amount || 
                (balanceData.total_online_sale_amount + 
                 balanceData.total_offline_suppliers_amount + 
                 balanceData.total_service_suppliers_amount + 
                 balanceData.total_logistic_vendors_amount + 
                 balanceData.total_users_wallet_amount),
        type: "total_outstanding"
      },
      {
        particular_name: "Total Online Suppliers Amount",
        amount: balanceData.total_online_sale_amount,
        type: "online_suppliers"
      },
      {
        particular_name: "Total Offline Suppliers Amount",
        amount: balanceData.total_offline_suppliers_amount,
        type: "offline_suppliers"
      },
      {
        particular_name: "Total Service Suppliers Amount",
        amount: balanceData.total_service_suppliers_amount,
        type: "service_suppliers"
      },
      {
        particular_name: "Total Logistic Vendors Amount",
        amount: balanceData.total_logistic_vendors_amount,
        type: "logistics_vendors"
      },
      {
        particular_name: "Total User's Wallet Amount",
        amount: balanceData.total_users_wallet_amount,
        type: "users_wallet"
      }
    ];
  };

  const outstandingDetailsColumnDefs = [
    {
      header: "S.No",
      accessor: "s_no",
      render: (_, index) => index + 1,
      width: 80
    },
    {
      header: "User Name",
      accessor: "user_name",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => {
        if (row?.seller) {
          return `${row.seller.first_name || ''} ${row.seller.last_name || ''}`.trim();
        } else if (row?.order?.user) {
          return `${row.order.user.first_name || ''} ${row.order.user.last_name || ''}`.trim();
        } else if (row?.first_name || row?.last_name) {
          return `${row.first_name || ''} ${row.last_name || ''}`.trim();
        }
        return 'N/A';
      }
    },
    {
      header: "Registration ID",
      accessor: "reg_id",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => {
        if (row?.seller?.reg_id) {
          return row.seller.reg_id;
        } else if (row?.order?.user?.reg_id) {
          return row.order.user.reg_id;
        } else if (row?.reg_id) {
          return row.reg_id;
        }
        return 'N/A';
      }
    },
    {
      header: "Business Name",
      accessor: "business_name",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => {
        if (row?.seller?.user_business?.business_name) {
          return row.seller.user_business.business_name;
        } else if (row?.order?.user?.user_business?.business_name) {
          return row.order.user.user_business.business_name;
        } else if (row?.user_business?.business_name) {
          return row.user_business.business_name;
        }
        return 'N/A';
      }
    },
    {
      header: "Nature of Business",
      accessor: "nature_of_business",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => {
        if (row?.seller?.user_business?.nature_of_business) {
          return row.seller.user_business.nature_of_business;
        } else if (row?.order?.user?.user_business?.nature_of_business) {
          return row.order.user.user_business.nature_of_business;
        } else if (row?.user_business?.nature_of_business) {
          return row.user_business.nature_of_business;
        }
        return 'N/A';
      }
    },
    {
      header: "Outstanding Amount",
      accessor: "amount",
      sortable: true,
      filter: false,
      flex: 1,
      render: (row) => {
        let amount = 0;
        if (row?.total_order_price) {
          amount = row.total_order_price;
        } else if (row?.order_price) {
          amount = row.order_price;
        } else if (row?.amount) {
          amount = row.amount;
        } else if (row?.wallet) {
          amount = row.wallet;
        }
        return formatCurrency(amount);
      }
    }
  ];
  
  const walletDetailsColumnDefs = [
    {
      header: "S.No",
      accessor: "s_no",
      render: (_, index) => index + 1,
      width: 80
    },
    {
      header: "User Name",
      accessor: "user_name",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => `${row?.first_name || ''} ${row?.last_name || ''}`.trim()
    },
    {
      header: "Registration ID",
      accessor: "reg_id",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.reg_id || 'N/A'
    },
    {
      header: "Business Name",
      accessor: "business_name",
      sortable: true,
      filter: true,
      flex: 1,
      render: (row) => row?.user_business?.business_name || 'N/A'
    },
    {
      header: "Wallet Amount",
      accessor: "wallet_amount",
      sortable: true,
      filter: false,
      flex: 1,
      render: (row) => formatCurrency(row?.wallet || 0)
    }
  ];

  const getExportData = () => {
    if (!data || data.length === 0) return [];
    
    const balanceData = data[0];
    
    return [
      {
        "Particular Name": "Total Outstanding Amount",
        "Amounts (Rs.)": balanceData.total_outstanding_amount || 
                (balanceData.total_online_sale_amount + 
                 balanceData.total_offline_suppliers_amount + 
                 balanceData.total_service_suppliers_amount + 
                 balanceData.total_logistic_vendors_amount + 
                 balanceData.total_users_wallet_amount)
      },
      {
        "Particular Name": "Total Online Suppliers Amount",
        "Amounts (Rs.)": balanceData.total_online_sale_amount
      },
      {
        "Particular Name": "Total Offline Suppliers Amount",
        "Amounts (Rs.)": balanceData.total_offline_suppliers_amount
      },
      {
        "Particular Name": "Total Service Suppliers Amount",
        "Amounts (Rs.)": balanceData.total_service_suppliers_amount
      },
      {
        "Particular Name": "Total Logistic Vendors Amount",
        "Amounts (Rs.)": balanceData.total_logistic_vendors_amount
      },
      {
        "Particular Name": "Total User's Wallet Amount",
        "Amounts (Rs.)": balanceData.total_users_wallet_amount
      }
    ];
  };
  
  const handleExportCSV = () => {
    exportToCSV(getExportData(), 'Balance Outstanding Report');
  };
  
  const handleExportExcel = () => {
    exportToExcel(getExportData(), 'Balance Outstanding Report');
  };
  
  const handleExportPDF = () => {
    exportToPDF(getExportData(), 'Balance Outstanding Report');
  };

  return (
    <>
      <div className="col-md-12">
        <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
  <h4 className="card-title mb-0">Balance Outstanding as on date</h4>
  <div className="d-flex gap-2">
    <button className='btn btn-sm btn-outline-primary' onClick={handleExportCSV}>
      Export to CSV
    </button>
    <button className='btn btn-sm btn-outline-success' onClick={handleExportExcel}>
      Export to Excel
    </button>
    <button className='btn btn-sm btn-outline-danger' onClick={handleExportPDF}>
      Export to PDF
    </button>
  </div>
</div>
          <div className="card-body">
            <div className='row mb-4'>
              <div className='col-md-4 row'>
                <label className="col-md-3 col-form-label" htmlFor="Date-from">From:</label>
                <div className="col-md-9">
                  <input 
                    type='date' 
                    value={startDate} 
                    onChange={handleStartDateChange} 
                    className="form-control" 
                    id="Date-from" 
                    name="Date-from"
                  />
                </div>
              </div>
              <div className='col-md-4 row'>
                <label className="col-md-3 col-form-label" htmlFor="Date-to">To:</label>
                <div className="col-md-9">
                  <input 
                    type='date' 
                    value={endDate} 
                    onChange={handleEndDateChange} 
                    className="form-control" 
                    id="Date-to" 
                    name="Date-to"
                  />
                </div>
              </div>
            </div>
            
            {loading ? (
              <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="table-responsive">
                <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                  <Table
                    data={getTableData()}
                    columns={columnDefs}
                  />
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Order Details Modal */}
        <Modal isOpen={orderDetailsModal} toggle={toggleOrderDetailsModal} size="xl">
          <ModalHeader toggle={toggleOrderDetailsModal}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                {modalTitle} ({orderDetailsData.length} records)
              </div>
              <div className="d-flex gap-2">
                <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV(orderDetailsData, 'order_details', 'Order Details')}>
                  Export to CSV
                </button>
                <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel(orderDetailsData, 'order_details', 'Order Details')}>
                  Export to Excel
                </button>
                <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF(orderDetailsData, 'order_details', 'Order Details')}>
                  Export to PDF
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            {orderDetailsData.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={orderDetailsData}
                  columns={outstandingDetailsColumnDefs}
                />
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No order details available for the selected period</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Logistics Details Modal */}
        <Modal isOpen={logisticsDetailsModal} toggle={toggleLogisticsDetailsModal} size="xl">
          <ModalHeader toggle={toggleLogisticsDetailsModal}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                {modalTitle} ({logisticsDetailsData.length} records)
              </div>
              <div className="d-flex gap-2">
                <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV(logisticsDetailsData, 'logistics_details', 'Logistics Details')}>
                  Export to CSV
                </button>
                <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel(logisticsDetailsData, 'logistics_details', 'Logistics Details')}>
                  Export to Excel
                </button>
                <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF(logisticsDetailsData, 'logistics_details', 'Logistics Details')}>
                  Export to PDF
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            {logisticsDetailsData.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={logisticsDetailsData}
                  columns={outstandingDetailsColumnDefs}
                />
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No logistics details available for the selected period</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Online Suppliers Modal */}
        <Modal isOpen={onlineOrdersModal} toggle={toggleOnlineOrdersModal} size="xl">
          <ModalHeader toggle={toggleOnlineOrdersModal}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                {modalTitle} ({onlineOrdersData.length} records)
              </div>
              <div className="d-flex gap-2">
                <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV(onlineOrdersData, 'online_orders', 'Online Orders')}>
                  Export to CSV
                </button>
                <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel(onlineOrdersData, 'online_orders', 'Online Orders')}>
                  Export to Excel
                </button>
                <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF(onlineOrdersData, 'online_orders', 'Online Orders')}>
                  Export to PDF
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            {onlineOrdersData.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={onlineOrdersData}
                  columns={outstandingDetailsColumnDefs}
                />
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No online suppliers outstanding for the selected period</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Offline Suppliers Modal */}
        <Modal isOpen={offlineOrdersModal} toggle={toggleOfflineOrdersModal} size="xl">
          <ModalHeader toggle={toggleOfflineOrdersModal}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                {modalTitle} ({offlineOrdersData.length} records)
              </div>
              <div className="d-flex gap-2">
                <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV(offlineOrdersData, 'offline_orders', 'offline Orders')}>
                  Export to CSV
                </button>
                <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel(offlineOrdersData, 'offline_orders', 'offline Orders')}>
                  Export to Excel
                </button>
                <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF(offlineOrdersData, 'offline_orders', 'offline Orders')}>
                  Export to PDF
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            {offlineOrdersData.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={offlineOrdersData}
                  columns={outstandingDetailsColumnDefs}
                />
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No offline suppliers outstanding for the selected period</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Service Suppliers Modal */}
        <Modal isOpen={serviceOrdersModal} toggle={toggleServiceOrdersModal} size="xl">
          <ModalHeader toggle={toggleServiceOrdersModal}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                {modalTitle} ({serviceOrdersData.length} records)
              </div>
              <div className="d-flex gap-2">
                <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV(serviceOrdersData, 'service_orders', 'service Orders')}>
                  Export to CSV
                </button>
                <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel(serviceOrdersData, 'service_orders', 'service Orders')}>
                  Export to Excel
                </button>
                <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF(serviceOrdersData, 'service_orders', 'service Orders')}>
                  Export to PDF
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            {serviceOrdersData.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={serviceOrdersData}
                  columns={outstandingDetailsColumnDefs}
                />
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No service suppliers outstanding for the selected period</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Logistics Vendors Modal */}
        <Modal isOpen={logisticsOrdersModal} toggle={toggleLogisticsOrdersModal} size="xl">
          <ModalHeader toggle={toggleLogisticsOrdersModal}>
          <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                {modalTitle} ({logisticsOrdersData.length} records)
              </div>
              <div className="d-flex gap-2">
                <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV(logisticsOrdersData, 'logistics_orders', 'logistics Orders')}>
                  Export to CSV
                </button>
                <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel(logisticsOrdersData, 'logistics_orders', 'logistics Orders')}>
                  Export to Excel
                </button>
                <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF(logisticsOrdersData, 'logistics_orders', 'logistics Orders')}>
                  Export to PDF
                </button>
              </div>
            </div>
               </ModalHeader>
          <ModalBody>
            {logisticsOrdersData.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={logisticsOrdersData}
                  columns={outstandingDetailsColumnDefs}
                />
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No logistics vendors outstanding for the selected period</p>
              </div>
            )}
          </ModalBody>
        </Modal>

        {/* Users Wallet Modal */}
        <Modal isOpen={usersWalletModal} toggle={toggleUsersWalletModal} size="xl">
          <ModalHeader toggle={toggleUsersWalletModal}>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                {modalTitle} ({usersWalletData.length} records)
              </div>
              <div className="d-flex gap-2">
                <button className='btn btn-sm btn-outline-primary' onClick={() => handleExportDetailCSV(usersWalletData, 'usersWallet', 'usersWallet Orders')}>
                  Export to CSV
                </button>
                <button className='btn btn-sm btn-outline-success' onClick={() => handleExportDetailExcel(usersWalletData, 'usersWallet', 'usersWallet Orders')}>
                  Export to Excel
                </button>
                <button className='btn btn-sm btn-outline-danger' onClick={() => handleExportDetailPDF(usersWalletData, 'usersWallet', 'usersWallet Orders')}>
                  Export to PDF
                </button>
              </div>
            </div>
          </ModalHeader>
          <ModalBody>
            {usersWalletData.length > 0 ? (
              <div className="ag-theme-alpine" style={{ height: 400, width: '100%' }}>
                <Table
                  data={usersWalletData}
                  columns={walletDetailsColumnDefs}
                />
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted">No users with wallet balance for the selected period</p>
              </div>
            )}
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default BalanceOutstanding;